import React from 'react'

const PartTwelve = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 9 เบ็ดเตล็ดทั่วไป</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.1 ทั้งสองฝ่ายทราบและเข้าในดีว่า ความสัมพันธ์ของคู่สัญญานี้มีลักษณะเป็นการจ้างทำของเท่านั้นโดยไม่มีนิติสัมพันธ์ตามกฎหมายในลักษณะเป็น หุ้นส่วน ตัวแทน จ้างแรงงานกันแต่อย่างใด
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.2 ในบริเวณสถานที่ปลูกสร้างผู้ว่าจ้างจะต้องเป็นผู้ชำระค่าธรรมเนียมไฟฟ้า,ประปาชั่วคราวรวมถึงจะต้องมีบริเวณสำหรับสร้างบ้านพักคนงานและที่เก็บกองวัสดุอุปกรณ์ในการก่อสร้าง หรือมิฉะนั้น ผู้ว่าจ้างจะเป็นผู้จัดหาและรับผิดชอบค่าใช้จ่ายในการดำเนินการดังกล่าวทั้งหมด แต่ในส่วนของการชำระค่าไฟฟ้า ค่าน้ำประปาในระหว่างการปลูกสร้าง ผู้รับจ้างเป็นผู้ชำระทั้งหมด
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.3 สิ่งปลูกสร้างต่างๆ ที่ผู้รับจ้างได้ทำลงไปในที่ดิน ให้ถือว่ายังไม่เป็นส่วนควบของที่ดินเฉพาะส่วนที่ผู้ว่าจ้างค้างชำระ
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.4 ผู้ว่าจ้าง หรือ บริวาร ไม่มีสิทธิ์ใช้สอยหรือเข้าครอบครองในบ้านหลังดังกล่าวจนกว่าผู้ว่าจ้างจะได้ชำระเงินให้แก่ผู้รับจ้างตามสัญญาครบถ้วน
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;9.5 การบอกกล่าวใดๆ ตามสัญญานี้ ต้องทำเป็นหนังสือและแจ้งยังคู่สัญญาอีกฝ่ายหนึ่งตามที่อยู่ข้างต้น หรือที่อยู่อื่นตามที่คู่สัญญาฝ่ายใดฝ่ายหนึ่งจะได้รับแจ้งเป็นหนังสือให้อีกฝ่ายหนึ่งทราบ หากเป็นการแจ้งทางไปรษณีย์ให้ส่งโดยไปรษณีย์ตอบรับ และให้ถือว่าคู่สัญญาฝ่ายที่รับแจ้งทราบตั้งแต่วันที่ได้รับ
                </p> 
            </div>
        </div>
        <br/>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;สัญญาฉบับนี้ทำขึ้นเป็นสอบฉบับ มีข้อความถูกต้องตรงกัน และคู่สัญญาได้ตรวจอ่านเรียบร้อยแล้ว รับว่าตรงตามเจตนาทุกประการ จังได้ลงลายมือชื่อไว้ต่อหน้าพยาน และต่างฝ่ายต่างยึดถือสัญญานี้ไว้ฝ่ายละ 1 ฉบับ
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartTwelve